import { css } from '@emotion/css';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { RootState } from 'src/features';
import { actions } from 'src/features/fortune';
import { sendEvent } from 'src/lib/google-analytics';
import { BottomImage } from './BottomImage';
import { PointGetButton } from './PointGetButton';
import { PointGetUserInfo } from './PointGetUserInfo';
import { PointRate } from './PointRate';
import { UserInfoProps } from './UserInfo';

type FortuneHomePointGetProps = {
  pointFactor: number;
  userInfo: UserInfoProps;
};

export const FortuneHomePointGet: React.FC<FortuneHomePointGetProps> = ({
  pointFactor,
  userInfo
}) => {
  const { t } = useTranslation('fortune');
  const updateStatus = useSelector((state: RootState) => state.fortune.updateStatus);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (updateStatus?.state === 'error') {
      history.push(`/players/fortune/home/error?type=${updateStatus.error}`);
    }
  }, [history, updateStatus]);

  const handlePointGetClick = () => {
    const pointFactorStr = pointFactor.toString();
    dispatch(actions.updateTodaysFortune());
    sendEvent('fortune_get_point', 'click', pointFactorStr);
  };

  const isLoading = updateStatus?.state === 'pending';

  return (
    <div
      className={css`
        flex: 1 0 auto;
        text-align: center;
        position: relative;
        color: #4d3906;
        padding: 16px 0 120px;

        .collect-point,
        .desc,
        .point-get {
          max-width: 480px;
          margin: 0 auto;
          padding: 0 20px;
        }
        .fortune-home-image {
          margin: 16px 0;
        }
        .desc {
          font-size: 14px;
          color: #897a66;
          margin: 12px auto 20px;
        }

        .user-info {
          max-width: 480px;
          margin: 8px auto;
        }
      `}
    >
      <p className="collect-point">{t('collect_point')}</p>

      <div className="fortune-home-image">
        <PointRate pointFactor={pointFactor} />
      </div>

      <p className="desc">{t('collect_point_desc_01')}</p>

      <div className="point-get">
        <PointGetButton onClick={handlePointGetClick} loading={isLoading}>
          {t('button_get_point')}
        </PointGetButton>
      </div>

      {/* ハッケミィ & プレイヤー情報 */}
      <div className="user-info">
        <PointGetUserInfo {...userInfo} />
      </div>

      <div
        className={css`
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
        `}
      >
        <BottomImage pointFactor={pointFactor} />
      </div>
    </div>
  );
};
